<template>
  <v-dialog v-model="show" width="800">
    <v-card>
      <v-card-title class="d-flex align-center">
        <div>{{ $tc('route_violation', 2) }}</div>
        <v-spacer/>
        <v-btn fab text small @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-list>
          <div v-for="(product, productLabel) in violationsByProductLabel" :key="productLabel">
            <v-list-item-title class="font-weight-bold">
              {{ productLabel }}
            </v-list-item-title>
            <v-list-item v-for="(violation, index) in product" :key="index">
              <v-list-item-icon>
                <v-icon color="error">
                  {{ violation.mdiIcon }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-wrap">
                  {{ violation.formattedMessage }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span v-if="violation.start !== violation.end">
                    <multi-time-display :time="violation.start"/> -<multi-time-display :time="violation.end"/>
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list>
        <a @click="showViolationAssessmentForm">
          {{ $t('go_to_root_cause_analysis') }}
        </a>
      </v-card-text>
    </v-card>
    <template #activator="{on, attrs}">
      <div class="ml-5" v-if="size(violations) > 0">
        <vf-tooltip :text="$tc('violation', 2)">
          <v-badge :content="size(violations)" offset-x="13" offset-y="13" overlap color="danger darken-1" bordered>
            <v-btn small fab dark v-on="on" v-bind="attrs" color="danger" elevation="0">
              <v-icon size="30">
                mdi-exclamation-thick
              </v-icon>
            </v-btn>
          </v-badge>
        </vf-tooltip>
      </div>
    </template>
  </v-dialog>
</template>

<script>
import { filter, groupBy, size, get } from 'lodash'
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay'
import VfTooltip from '@/components/shared/VfTooltip'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'

export default {
  name: 'RouteViolationsDialog',
  components: {
    MultiTimeDisplay,
    VfTooltip
  },
  mixins: [
    CurrentUserMixin
  ],
  props: {
    route: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    size: size,
    showViolationAssessmentForm () {
      this.$emit('show-assessment-form')
    }
  },
  computed: {
    violations () {
      return filter(this.route.route_violations, violation => violation.level === 'fatal')
    },
    violationsByProductLabel () {
      return groupBy(this.violations, violation => get(violation, 'route_product.label', this.$t('none')))
    }
  }
}
</script>

<style scoped>
</style>
